/**
 * 接口代理配置
 *
 * @type {Object}
 */
import { apiHost } from './setup';

export type ParamsType = {
    url: string,
    headers?: <T>(x: T) => T | { [key: string]: string | number }
    params?: <T>(x: T) => T | { [key: string]: string | number }
    responseHandle?: <T>(x: T) => T
}

interface ApiInterface {
    [key: string]: ParamsType
}

const apis: ApiInterface = {
  '@api/': {
    url: `${apiHost.api}/api/`
  },
  '@bapi/': {
    url: `${apiHost.api}/bapi/`
  },
  '@capi/': {
    url: `${apiHost.api}/capi/`
  },
  '@plazaApi/': {
    url: `${apiHost.plazaApi}/api/`
  },
  '@uapi/': {
    url: `${apiHost.api}/uapi/`
  },
  '@mock/': {
    url: 'https://mock.apifox.cn/m1/2432145-0-default/'
  }
};

export default apis;
